/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientAllergy
 */
export interface PccPatientAllergy {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    category: PccPatientAllergyCategoryEnum;
    /**
     * 
     */
    clinical_status: PccPatientAllergyClinicalStatusEnum;
    /**
     * 
     */
    type: PccPatientAllergyTypeEnum;
    /**
     * 
     */
    display: string;
    /**
     * 
     */
    reaction_note?: string;
    /**
     * 
     */
    severity?: PccPatientAllergySeverityEnum;
    /**
     * 
     */
    resolved_date?: string;
    /**
     * 
     */
    pcc_historical_allergy_intolerance_id?: string;
}


/**
 * @export
 */
export const PccPatientAllergyCategoryEnum = {
    Drug: 'Drug',
    Food: 'Food',
    Environmental: 'Environmental',
    Substance: 'Substance',
    Other: 'Other',
} as const;
export type PccPatientAllergyCategoryEnum = typeof PccPatientAllergyCategoryEnum[keyof typeof PccPatientAllergyCategoryEnum];

/**
 * @export
 */
export const PccPatientAllergyClinicalStatusEnum = {
    Active: 'active',
    PriorHistory: 'priorHistory',
    Resolved: 'resolved',
} as const;
export type PccPatientAllergyClinicalStatusEnum = typeof PccPatientAllergyClinicalStatusEnum[keyof typeof PccPatientAllergyClinicalStatusEnum];

/**
 * @export
 */
export const PccPatientAllergyTypeEnum = {
    Allergy: 'Allergy',
    Intolerance: 'Intolerance',
    PropensityToAdverseReactions: 'Propensity to Adverse Reactions',
    Unknown: 'Unknown',
} as const;
export type PccPatientAllergyTypeEnum = typeof PccPatientAllergyTypeEnum[keyof typeof PccPatientAllergyTypeEnum];

/**
 * @export
 */
export const PccPatientAllergySeverityEnum = {
    Mild: 'Mild',
    Moderate: 'Moderate',
    Severe: 'Severe',
    Unknown: 'Unknown',
} as const;
export type PccPatientAllergySeverityEnum = typeof PccPatientAllergySeverityEnum[keyof typeof PccPatientAllergySeverityEnum];


/**
 * Check if a given object implements the PccPatientAllergy interface.
 */
export function instanceOfPccPatientAllergy(value: object): value is PccPatientAllergy {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('clinical_status' in value) || value['clinical_status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('display' in value) || value['display'] === undefined) return false;
    return true;
}

export function PccPatientAllergyFromJSON(json: any): PccPatientAllergy {
    return PccPatientAllergyFromJSONTyped(json, false);
}

export function PccPatientAllergyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientAllergy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'category': json['category'],
        'clinical_status': json['clinical_status'],
        'type': json['type'],
        'display': json['display'],
        'reaction_note': json['reaction_note'] == null ? undefined : json['reaction_note'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'resolved_date': json['resolved_date'] == null ? undefined : json['resolved_date'],
        'pcc_historical_allergy_intolerance_id': json['pcc_historical_allergy_intolerance_id'] == null ? undefined : json['pcc_historical_allergy_intolerance_id'],
    };
}

export function PccPatientAllergyToJSON(json: any): PccPatientAllergy {
    return PccPatientAllergyToJSONTyped(json, false);
}

export function PccPatientAllergyToJSONTyped(value?: PccPatientAllergy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': value['category'],
        'clinical_status': value['clinical_status'],
        'type': value['type'],
        'display': value['display'],
        'reaction_note': value['reaction_note'],
        'severity': value['severity'],
        'resolved_date': value['resolved_date'],
        'pcc_historical_allergy_intolerance_id': value['pcc_historical_allergy_intolerance_id'],
    };
}

